import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Servicos from './components/Servicos';
import Sobre from './components/Sobre';
import ProjetosDemo from './components/ProjetosDemo';
//import Portfolio from './components/Portfolio';
import Precos from './components/Precos';
import Contato from './components/Contato';
import Footer from './components/Footer';
function Home() {
  return (
    <>
      <Hero />
      <Sobre />
      <Precos />
      <ProjetosDemo /> 
      <Servicos />
      <Contato />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;